export const version = process.env.VUE_APP_VERSION
export const source = 4 // 请求来源：1-安卓；2-IOS；3-微信；4-web；5-wxmp；6-h5
export const isPrerender = !!window['__PRERENDER_INJECTED'] // 是否为预渲染

const isProd = process.env.VUE_APP_ENV === 'prod'

let apiUrlEnv = ''
if (isProd) {
  apiUrlEnv = 'https://content.api.deepmindcog.com/'
} else {
  apiUrlEnv = 'https://content.api.deepmindcog.com/'
  // apiUrlEnv = 'http://localhost:9824/'
}

export let baseURL = apiUrlEnv // 请求后端地址
export let searchParamCache = 'searchParamCache' // 查询条件缓存key

// TODO：接口通用请求参数—待废弃
export const params = {
  version,
  source
}

// 兼容旧导出方式
export default {
  baseURL,
  searchParamCache
}
